import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../utils/translations';
import {Button} from '@homeaway/react-buttons';
import {ALERT_SUCCESS__32} from '@homeaway/svg-defs/lib/defs/ALERT_SUCCESS__32';
import {SVGIcon} from '@homeaway/react-svg';
import edap from '@homeaway/edap-wrapper';

export class PaymentSteps extends React.PureComponent {
    static propTypes = {
        translations: PropTypes.shape({}).isRequired,
        tripDetailsUrl: PropTypes.string.isRequired,
    };

    static defaultProps = {
        translations: {},
    };

    onClickViewTripDetails() {
        edap().push({
            name: 'generic.click',
            data: {
                eventaction: 'trip.details.click',
                eventcategory: 'traveler activity',
                eventlabel: 'payment confirmation cta',
            },
        });
    }

    render() {
        const {translations, tripDetailsUrl} = this.props;

        return (
            <div className="ConfirmationSteps col-md-8 col-md-offset-2 col-sm-12">
                <span className="text-success hidden-xs">
                    <SVGIcon markup={ALERT_SUCCESS__32} useFill />
                </span>
                <h1>
                    {translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.paymentConfirmation.title'
                    )}
                </h1>
                <Button
                    className="ConfirmationSteps__button"
                    href={tripDetailsUrl}
                    label={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.cta'
                    )}
                    onClick={this.onClickViewTripDetails}
                />
            </div>
        );
    }
}
